export const blockIconsPrivacyandsecurityEnhancedEncryptionNew = (
	<span className='material-symbols-outlined'>enhanced_encryption</span>
);
